import { render } from "./profPage.vue?vue&type=template&id=2f04f964"
import script from "./profPage.vue?vue&type=script&lang=js"
export * from "./profPage.vue?vue&type=script&lang=js"

import "./profPage.vue?vue&type=style&index=0&id=2f04f964&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__